const fields = [
  'PDB_Standortinformationen_Checkliste_verschickt',
  'PDB_Standortinformationen_Behoerden_Kontakt_ob',
  'PDB_Standortinformationen_Behoerden_Kontakt_welche',
]

const key = 'Informationen zum Standort'

export const fieldOrderInformationenZumStandort = { [key]: { fields } }
export const formGroupInformationenZumStandort = {
  key,
  title: key,
  form: key,
}